import React, { useState, useEffect } from 'react';
import { Linkedin, Users, Building, ExternalLink } from 'lucide-react';

const LinkedInWidget = ({ companyUrl, variant = 'default' }) => {
  const [companyData, setCompanyData] = useState(null);
  const [loading, setLoading] = useState(false);

  // Extract company name from LinkedIn URL
  const getCompanyName = (url) => {
    if (!url) return 'Blu Digital Technologies';
    const match = url.match(/\/company\/(.+)$/);
    return match ? match[1].replace(/-/g, ' ').replace(/\b\w/g, l => l.toUpperCase()) : 'Blu Digital Technologies';
  };

  const companyName = getCompanyName(companyUrl);

  // Since we can't directly access LinkedIn API without proper authentication,
  // we'll create a mock widget that looks professional
  useEffect(() => {
    setCompanyData({
      name: 'Blu Digital Technologies',
      followers: '500+',
      industry: 'Technology Services',
      description: 'Transforming Government & Enterprise Digital Infrastructure'
    });
  }, []);

  if (variant === 'simple') {
    return (
      <div className="flex items-center space-x-3">
        <a
          href={companyUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center space-x-2 text-gray-600 hover:text-blue-600 transition-colors"
        >
          <div className="w-8 h-8 bg-blue-600 rounded flex items-center justify-center">
            <Linkedin size={16} className="text-white" />
          </div>
          <span className="font-medium">Follow us on LinkedIn</span>
          <ExternalLink size={14} />
        </a>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-lg border border-gray-200 p-4 shadow-sm hover:shadow-md transition-shadow">
      {/* Header */}
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center space-x-2">
          <div className="w-8 h-8 bg-blue-600 rounded flex items-center justify-center">
            <Linkedin size={16} className="text-white" />
          </div>
          <span className="text-sm font-medium text-gray-900">LinkedIn</span>
        </div>
        <a
          href={companyUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-600 hover:text-blue-800 transition-colors"
        >
          <ExternalLink size={16} />
        </a>
      </div>

      {/* Company Info */}
      <div className="space-y-3">
        <div>
          <h3 className="font-semibold text-gray-900 text-sm">{companyData?.name}</h3>
          <p className="text-xs text-gray-600">{companyData?.industry}</p>
        </div>

        <p className="text-xs text-gray-600 line-clamp-2">
          {companyData?.description}
        </p>

        <div className="flex items-center justify-between text-xs text-gray-500">
          <div className="flex items-center space-x-1">
            <Users size={12} />
            <span>{companyData?.followers} followers</span>
          </div>
          <div className="flex items-center space-x-1">
            <Building size={12} />
            <span>Company</span>
          </div>
        </div>

        {/* Follow Button */}
        <a
          href={companyUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="w-full bg-blue-600 text-white text-xs font-medium py-2 px-3 rounded-md hover:bg-blue-700 transition-colors flex items-center justify-center space-x-1"
        >
          <Linkedin size={14} />
          <span>Follow on LinkedIn</span>
        </a>
      </div>
    </div>
  );
};

export default LinkedInWidget;